import { ItemWithId } from 'services/constants/types';
import {
	ETableStructureAlign,
	ETableStructureType,
	TTableStructure,
} from 'services/constants/tableStructureTypes';
import { EIconButtons } from 'services/constants/iconsTypes';

export const PPWR_COUNTRY_EXCLUSION_ACTIONS = {
	EDIT: 'Edit',
};

export type TPpwrCountryExclusionTableRow = ItemWithId & {
	countryCode: string;
	reason: string;
	reportsDoneBy: string;
	lucid: string;
	validTill: string | null;
	dashboardUpdatedAt: string | null;
	dashboardUpdatedBy: string;
};

export const tableStructure: TTableStructure<keyof TPpwrCountryExclusionTableRow>[] = [
	{
		name: 'ID',
		selector: 'id',
		show: false,
		sortable: false,
		filterable: false,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Country',
		selector: 'countryCode',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.COUNTRY_CODE_EU,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Reason',
		selector: 'reason',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.MULTILINE_TEXT,
		align: ETableStructureAlign.LEFT,
		colSpan: 2,
	},
	{
		name: 'Reports Done By',
		selector: 'reportsDoneBy',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'LUCID',
		selector: 'lucid',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Valid Till',
		selector: 'validTill',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Updated At',
		selector: 'dashboardUpdatedAt',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.DATE_TIME,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Updated By',
		selector: 'dashboardUpdatedBy',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: '',
		selector: 'actions' as keyof TPpwrCountryExclusionTableRow,
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
		buttons: [
			{
				name: PPWR_COUNTRY_EXCLUSION_ACTIONS.EDIT,
				icon: EIconButtons.EDIT,
				tooltip: 'Edit',
			},
		],
	},
];
